import { render, staticRenderFns } from "./InquiryCreditCharge.vue?vue&type=template&id=83bdd1ee"
import script from "./InquiryCreditCharge.vue?vue&type=script&lang=js"
export * from "./InquiryCreditCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports